import type {YAxisId} from "~/components/reports/widgetSpecific/comboChart";
import AreaChart from "~/svgs/areaChart.svg?react";
import MultiBarChart from "~/svgs/charts/multiBarGraph.svg?react";
import LineChart from "~/svgs/lineChart.svg?react";
import type {EnumDictionary} from "~/typeDefinitions";
import {NumberSystems} from "~/utilities/typeDefinitions";

export type ChartSeries = {
    name: string;
    color: string;
    isNameUpdated: boolean;
    label: string;
    yAxisId: YAxisId;
};

export enum ComposedChartType {
    bar = "1419f381-226d-4835-87b0-71bdfd332629",
    line = "26b75ed2-8258-471d-a736-ba737e9fcb71",
    area = "97198e06-89af-4401-9692-1e1bd257e69b",
}

export const composedChartSeriesIcons: EnumDictionary<
    ComposedChartType,
    {
        icon: React.ComponentType<{
            className?: string;
        }>;
    }
> = {
    [ComposedChartType.bar]: {
        icon: MultiBarChart,
    },
    [ComposedChartType.line]: {
        icon: LineChart,
    },
    [ComposedChartType.area]: {
        icon: AreaChart,
    },
};

export type ComboChartSeries = ChartSeries & {
    chartType: ComposedChartType;
};

export type EditableReportBarGraphData = {
    chartData: Array<Record<string, string | number | null>>;
    chartSeries: Array<ChartSeries>;
    minYValue: number;
    maxYValue: number;
    minYValueSecondary: number | null;
    maxYValueSecondary: number | null;
};
export type EditableReportLineGraphData = {
    chartData: Array<Record<string, string | number | null>>;
    chartSeries: Array<ChartSeries>;
    minYValue: number;
    maxYValue: number;
    minYValueSecondary: number | null;
    maxYValueSecondary: number | null;
};
export type EditableReportAreaGraphData = {
    chartData: Array<Record<string, string | number | null>>;
    chartSeries: Array<ChartSeries>;
    minYValue: number;
    maxYValue: number;
    minYValueSecondary: number | null;
    maxYValueSecondary: number | null;
};

export type EditableReportComboChartData = {
    chartData: Array<Record<string, string | number | null>>;
    chartSeries: Array<ComboChartSeries>;
    minYValue: number;
    maxYValue: number;
    minYValueSecondary: number | null;
    maxYValueSecondary: number | null;
};
export type EditableReportPieChartData = Array<{
    name: string;
    value: number;
    color: string;
    key: string;
    label: string;
} & Record<string, string | number>>;

export type EditableReportRingProgressData = Array<{
    value: number;
    color: string;
}>;

export type EditableReportTableData = Array<
    Record<string, string | number | null>
>;

export const numberSystemsMetadata: EnumDictionary<
    NumberSystems,
    {humanReadableName: string}
> = {
    [NumberSystems.indian]: {
        humanReadableName: "Indian",
    },
    [NumberSystems.international]: {
        humanReadableName: "International",
    },
    [NumberSystems.none]: {
        humanReadableName: "None",
    },
};
